import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { MessageService } from 'primeng/components/common/messageservice';

import { PerfilEnum } from '../../../base/enum/perfil';
import { Comunicado } from '../../../base/vo/comunicado';
import { AdminComunicadosService } from '../admin-comunicados.service';


@Component({
  selector: 'app-admin-comunicados-inserir',
  templateUrl: './admin-comunicados-inserir.component.html',
  styleUrls: ['./admin-comunicados-inserir.component.css']
})
export class AdminComunicadosInserirComponent implements OnInit {

  @ViewChild('fileInput') fileInput: ElementRef;

  comunicado: Comunicado;
  credenciado: string;
  credenciados: Array<any> = [];
  file: File;
  fileLoaded = false;
  listErrors: any;
  loading = false;
  preview: any;
  previewName: string;
  ptbr: any;

  caracteres = 4000;

  listPerfil: string[];

  constructor(
    private adminComunicadosService: AdminComunicadosService,
    public router: Router,
    public messageService: MessageService
  ) { }

  ngOnInit() {
    this.ptbr = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
        'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
      monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
      today: 'Hoje',
      clear: 'Limpar'
    };

    this.comunicado = new Comunicado();
    this.comunicado.corpo = '';
    this.comunicado.requerConfirmacao = false;
    this.credenciado = undefined;
    this.credenciados = [];
    this.listPerfil = this.enumToArray(PerfilEnum);

  }

  // Turn enum into array
  enumToArray(enumme) {
    // helper
    const StringIsNumber = value => (isNaN(Number(value)) === false && Number(value) != 0);
    // TODO: remover o perfil admin
    return Object.keys(enumme).filter(StringIsNumber).map(key => enumme[key]);
  }

  selecionarImagem() {
    this.fileInput.nativeElement.click();
  }

  onChangeFile(e) {
    if (e.target.files.length > 0) {
      this.file = e.target.files[0];
      this.fileInput.nativeElement.value = null;
      this.fileLoaded = true;
    }
  }

  incluirImagem() {
    this.previewName = this.file.name;

    const reader = new FileReader();

    reader.onload = (event: any) => {
      this.preview = event.target.result;

      this.fileLoaded = false;
    };

    reader.readAsDataURL(this.file);
  }

  removerImagem() {
    this.preview = null;
    this.file = null;
  }

  publicar() {
    this.loading = true;
    this.setUsuariosComunicado();

    if (this.caracteres < 0) {
      this.loading = false;

      return;
    }

    this.adminComunicadosService.publicarComunicado(this.comunicado, this.file).subscribe(
      response => {
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Comunicados', detail: 'Comunicado publicado com sucesso!' });
        this.router.navigate(['/admin/comunicados']);
      },
      errorResponse => {
        this.loading = false;
        this.listErrors = errorResponse.error.errors;
      });
  }

  private setUsuariosComunicado() {
    this.comunicado.usuarios = [];
    for (let i = 0; i < this.credenciados.length; i++) {
      this.comunicado.usuarios.push(this.credenciados[i].codigo);
    }
  }

  getMsgErro(campo: string) {
    if (campo === 'corpo' && this.caracteres < 0) {
      return 'Número de caracteres Excedidos';
    }

    if (this.listErrors && campo) {
      for (let index = 0; index < this.listErrors.length; index++) {
        if (this.listErrors[index].field === campo) {
          const message = this.listErrors[index].message;

          return message[0].toUpperCase() + message.slice(1);
        }
      }
    }

    return null;
  }

  adicionarCredenciado() {
    if (this.containsCredenciado()) {
      this.messageService.add({ severity: 'error', summary: 'Credenciado', detail: 'Este credenciado já foi incluído na lista!' });
      return;
    }

    if (this.credenciado) {
      this.loading = true;
      this.adminComunicadosService.buscarDadosPrestador(this.credenciado).subscribe(
        response => {
          this.loading = false;
          this.credenciados.push(response.data);
          this.credenciado = undefined;
          this.messageService.add({ severity: 'success', summary: 'Credenciado', detail: 'Credenciado adicionado com sucesso!' });
        },
        errorResponse => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Credenciado', detail: 'Credenciado não encontrado!' });
        });
    }
  }

  removerCredenciado(index) {
    this.credenciados.splice(index, 1);
  }

  containsCredenciado(): boolean {
    if (this.credenciados && this.credenciado) {
      for (let i = 0; i < this.credenciados.length; i++) {
        if (this.credenciados[i].codigo) {
          if (this.credenciados[i].codigo == this.credenciado) {
            return true;
          }
        }
      }
    }
    return false;
  }

  onChangeCheckPerfil(perfil: string, isChecked: boolean) {
    if (isChecked) {
      this.comunicado.perfis.push(perfil);
    } else {
      const index = this.comunicado.perfis.indexOf(perfil);
      this.comunicado.perfis.splice(index, 1);
    }
  }

  editorInit(event: any) {
    const quill = event.editor;
    const toolbar = quill.getModule('toolbar');

    toolbar.addHandler('image', () => {
      const value = prompt('URL da imagem');

      if (this.comunicado.corpo) {
        this.comunicado.corpo = `${this.comunicado.corpo} <img alt="img" src="${value}">`;
      } else {
        this.comunicado.corpo = `<img alt="img" src="${value}">`;
      }
    });

    function logHtmlContent() {
      console.log(quill.root.innerHTML);
      console.log(quill.root.innerHTML.getLength());
    }
  }

  contadorCaracteres(event: any) {
    if (event.textValue === '') {
      this.caracteres = 4000;
    } else {
      this.caracteres = 4000 - event.htmlValue.length;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/comunicados/inserir/admin-comunicados-inserir.component.ts